import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Title, Copy, Bold, Row } from "app/NativeComponents/common";

import Activity from "./Activity";
import Messages from "./Messages";
import Comps from "./Comps";
import SlideUpPanelWrapper from "app/NativeComponents/components/SlideUpPanelWrapper";
import ActivityTab from "./ActivityTab";

import { dismissMobileKeyboard } from "app/NativeActions";

import {
  resetActivity,
  getActivity,
  triggerActivityUpdate,
  updateNote,
  postMessageNote,
  updateDetailedOptions,
  getLeadConversations,
  appRedirect,
  setEditModal,
  setModal,
  toggleModal,
  sendTextMessage,
  updateOwnerInfo,
  openActivityTab,
  setMultisendFilters,
  getAllStatuses,
  updateBillingAddon
} from "app/NativeActions";

class ActivityArea extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected_to_number: props.set_to_phone_number
    };
    this.renderTabs = this.renderTabs.bind(this);

    this.updateSelectedToPhoneNumber = this.updateSelectedToPhoneNumber.bind(
      this
    );
  }

  getActivity(type = "load") {
    this.props.triggerActivityUpdate(false);
    this.props.resetActivity();
    this.props.getActivity({
      token: this.props.token,
      deal_id: this.props.active_property.deal.id,
      type: type
    });
    this.props.getAllStatuses({
      token: this.props.token
    });
  }

  updateSelectedToPhoneNumber(phone_number) {
    this.setState({ selected_to_number: phone_number });
  }

  getConversations() {
    if (
      this.props.active_property &&
      this.props.active_property.deal &&
      this.props.active_property.deal.removed != 1 &&
      !this.props.lead_conversations_loading
    ) {
      this.props.getLeadConversations({
        token: this.props.token,
        lead_id: this.props.active_property.deal.id
      });
    }
  }

  componentDidMount() {
    if (this.props.active_property && this.props.active_property.deal) {
      if (!this.props.loading) {
        this.getActivity();
      }

      this.getConversations();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.active_property) {
      if (
        this.props.active_property.deal &&
        this.props.active_property.deal.removed != 1
      ) {
        if (prevProps.active_property) {
          if (
            this.props.active_property.property_id !==
            prevProps.active_property.property_id
          ) {
            this.getActivity();
            this.getConversations();
          }
        } else if (!prevProps.active_property) {
          this.getActivity();
          this.getConversations();
        } else if (this.props.reload === true && prevProps.reload !== true) {
          this.getActivity("update");
          this.getConversations();
        }
      }
    }

    if (prevProps.set_to_phone_number !== this.props.set_to_phone_number) {
      this.updateSelectedToPhoneNumber(this.props.set_to_phone_number);
    }
  }

  renderTabs() {
    return (
      <Wrapper>
        <Row>
          <ActivityTab
            title="Activity"
            icon={this.props.desktop ? "notes" : "menu"}
            active={this.props.activity_tab == "activity"}
            onPress={() => {
              this.props.openActivityTab({
                activity_tab: "activity",
                is_activity_open:
                  this.props.activity_tab == "activity" &&
                  this.props.is_activity_open
                    ? false
                    : true
              });
              dismissMobileKeyboard();
            }}
            colors={this.props.colors}
          />
          {this.props.user.team_clearance_level > 0 && (
            <ActivityTab
              title="Messages"
              icon="chat"
              active={this.props.activity_tab == "messages"}
              onPress={() => {
                this.props.openActivityTab({
                  activity_tab: "messages",
                  is_activity_open:
                    this.props.activity_tab == "messages" &&
                    this.props.is_activity_open
                      ? false
                      : true
                });
                dismissMobileKeyboard();
              }}
              colors={this.props.colors}
              notifications={
                this.props.active_property.deal.message_notifications
              }
            />
          )}
          {this.props.user.team_clearance_level > 0 && (
            <ActivityTab
              title="Comps"
              icon="attach-money"
              active={this.props.activity_tab == "comps"}
              onPress={() => {
                this.props.openActivityTab({
                  activity_tab: "comps",
                  is_activity_open:
                    this.props.activity_tab == "comps" &&
                    this.props.is_activity_open
                      ? false
                      : true
                });
                dismissMobileKeyboard();
              }}
              colors={this.props.colors}
            />
          )}
        </Row>
      </Wrapper>
    );
  }

  renderPanelComponent() {
    switch (this.props.activity_tab) {
      case "activity":
      default:
        return (
          <Activity {...this.props} is_expanded={this.props.is_expanded} />
        );
      case "messages":
        return (
          <Messages
            {...this.props}
            is_expanded={this.props.is_expanded}
            selected_to_number={this.state.selected_to_number}
            updateSelectedToPhoneNumber={this.updateSelectedToPhoneNumber}
          />
        );
      case "comps":
        return <Comps {...this.props} property={this.props.active_property} />;
    }
  }

  render() {
    if (this.props.active_property) {
      if (this.props.active_property.deal) {
        if (this.props.isMobile || !this.props.is_expanded) {
          return (
            <SlideUpPanelWrapper
              colors={this.props.colors}
              handleComponent={this.renderTabs}
              onOpen={is_open => {
                this.props.openActivityTab({
                  is_activity_open: is_open,
                  activity_tab: this.props.activity_tab
                });
              }}
              is_open={this.props.is_activity_open}
              panelComponent={() => this.renderPanelComponent()}
            />
          );
        }

        return (
          <Wrapper
            style={{
              height: "100%",
              backgroundColor: this.props.colors.card_color,
              flex: 1
            }}
          >
            <Wrapper
              style={{
                backgroundColor: this.props.colors.background_color,
                paddingTop: 10
              }}
            >
              {this.renderTabs()}
            </Wrapper>

            {this.renderPanelComponent()}
          </Wrapper>
        );
      }

      if (this.props.device === "desktop") {
        return (
          <Wrapper
            style={{
              height: "100%",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Wrapper style={{ padding: 20 }}>
              <Title style={{ textAlign: "center" }}>
                There is nothing to display
              </Title>
              <Copy style={{ textAlign: "center" }}>
                Add this property to start and view an activity feed.
              </Copy>
            </Wrapper>
          </Wrapper>
        );
      }
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({
  auth,
  native,
  property_map,
  activity,
  drawer,
  settings,
  deal,
  message,
  billing,
  filter
}) => {
  const { token, user } = auth;
  const { all_statuses } = filter;
  const {
    device,
    platform,
    isIphoneX,
    window_height,
    isMobile,
    keyboard_showing
  } = native;
  const { stats } = drawer;
  const { active_property } = property_map;
  const { colors } = settings;
  const {
    lead_conversations_loading,
    lead_conversations,
    lead_to_phone_numbers,
    team_phone_number_groups,
    set_to_phone_number,
    set_from_phone_number
  } = message;

  const {
    drag_toggle,
    reload,
    dragged_value,
    activity_items,
    loading,
    detailed_options,
    activity_tab,
    is_activity_open
  } = activity;

  const { pricing, card_info, plan_modules, billing_addons } = billing;
  return {
    token,
    user,
    device,
    platform,
    isIphoneX,
    isMobile,
    window_height,
    stats,
    active_property,
    drag_toggle,
    reload,
    dragged_value,
    activity_items,
    loading,
    all_statuses,
    detailed_options,
    colors,

    lead_conversations_loading,
    lead_conversations,
    lead_to_phone_numbers,
    team_phone_number_groups,
    set_to_phone_number,
    set_from_phone_number,

    pricing,
    card_info,
    plan_modules,
    activity_tab,
    is_activity_open,
    keyboard_showing,
    billing_addons
  };
};

export default connect(mapStateToProps, {
  resetActivity,
  getActivity,
  triggerActivityUpdate,
  updateNote,
  postMessageNote,
  updateDetailedOptions,
  getLeadConversations,
  appRedirect,
  setEditModal,
  setModal,
  toggleModal,
  sendTextMessage,
  updateOwnerInfo,
  openActivityTab,
  setMultisendFilters,
  getAllStatuses,
  updateBillingAddon
})(ActivityArea);
